export default "__VITE_ASSET__fd703663__"